var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import create from 'zustand';
import { devtools, persist } from 'zustand/middleware';
var workflowStore = function (set) { return ({
    workflowStr: {},
    addWorkflowStore: function (workflow) {
        set(function (state) { return ({
            workflowStr: __spreadArray([workflow], state.workflowStr, true),
        }); });
    },
    removeWorkflowStore: function () {
        set(function (state) { return ({
            workflowStr: {},
        }); });
    },
}); };
var useWorkflowStore = create(devtools(persist(workflowStore, {
    name: 'workflow',
})));
export { useWorkflowStore };
